// The authenticated app shell: dark sidebar with brand + nav, signed-in user
// footer, and the routed page in the main column. Admin link only renders for
// users carrying the admin custom claim. Entitlement is per-exam now, so the
// shell shows no global subscription badge — see Dashboard/Billing for per-exam
// status.

import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const linkClass = ({ isActive }) => (isActive ? 'active' : undefined);

export default function AppShell() {
  const { user, isAdmin, signOut } = useAuth();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div>
          <div className="brand">
            theuth<span className="tick">/</span>prep
          </div>
          <div className="brand-sub">Medical exam preparation</div>
        </div>

        <nav className="nav">
          <NavLink to="/dashboard" className={linkClass}>
            Dashboard
          </NavLink>
          <NavLink to="/workspace" className={linkClass}>
            Workspace
          </NavLink>
          <NavLink to="/library" className={linkClass}>
            Library
          </NavLink>
          <NavLink to="/billing" className={linkClass}>
            Billing
          </NavLink>
          {isAdmin && (
            <NavLink to="/admin" className={linkClass}>
              Admin
            </NavLink>
          )}
        </nav>

        <div className="sidebar-foot">
          <div className="who">{user?.email ?? user?.uid}</div>
          <button
            className="btn btn-ghost btn-sm"
            style={{ marginTop: '0.6rem' }}
            onClick={() => void signOut()}
          >
            Sign out
          </button>
        </div>
      </aside>

      <main className="main">
        <Outlet />
      </main>
    </div>
  );
}
